<template>
  <div id="about" class="main">
    <Hero backimg="background-image:url(/images/hero-partners.jpg)"
      :title="`${$t('home.deep.title1')} ${$t('home.deep.title2')} ${$t('home.deep.title3')}`"
      sub="" />

    <div class="color-change">
      <AboutMenu />

      <Slide1 />

      <div class="base-wrap wrap-1280 align-center">
        <div class="item base-title-wrap">
          <div class="base-title ft-30">{{$t('about.base.title')}}</div>
<!--          <div class="base-sub ff-br ft-16">-->
<!--            China's Large Tuna Production Base-->
<!--          </div>-->
        </div>
        <div class="item right base-info ft-14" v-html="$t('about.base.text')"></div>
      </div>

      <div ref="imageswrap" class="base-wrap wrap-1500">
        <div class="item left">
          <div class="img-uncover about1">
            <img src="/images/about1.png" alt="">
          </div>
          <div class="base-info ft-14">
            {{$t('about.base.info[0]')}}
          </div>
        </div>
        <div class="item right down">
          <div class="img-uncover about2">
            <img src="/images/about2.png" alt="">
          </div>
          <div class="base-info ft-14">
            {{$t('about.base.info[1]')}}
          </div>
        </div>
      </div>

      <div class="text-center wrap-1280">
        <div class="base-title ft-30">{{$t('about.base.title2')}}</div>
<!--        <div class="base-sub ff-dr ft-14">-->
<!--          Healthy, Tasty Becomes Wealthy Innovation-->
<!--        </div>-->

        <div class="img-uncover about3">
          <img src="/images/about3.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import AboutMenu from '@/components/AboutMenu.vue'
import Slide1 from '@/components/Slide1.vue'
import scroll from '@/oceanSchool/scroll.js'
import {
  qsa, domAddClass, domRemoveClass
} from '@/util/dom.js'

export default {
  components: {
    Hero,
    AboutMenu,
    Slide1
  },

  beforeDestroy () {
    scroll.unbind('show-img')
  },

  mounted () {
    document.title = `${this.$t('nav.about')}-${this.$t('title')}`
    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0

      // setTimeout(() => {
      //   this.loader.hide()
      // }, 300)

      scroll.bind('show-img', this.scrollShowImgs)
    })
  },

  methods: {
    scrollShowImgs () {
      if (!this.$refs.imageswrap) return
      const imgs = qsa('.img-uncover', this.$el)

      for (let i = 0, len = imgs.length; i < len; i++) {
        const img = imgs[i]
        this.showImg(img)
      }
    },

    showImg (img) {
      const { top } = img.getBoundingClientRect()

      if (top < window.innerHeight) {
        domAddClass(img, 'show')
      } else {
        domRemoveClass(img, 'show')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main, .color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}

.wrap-1280 {
  max-width: 1280px;
}
.wrap-1500 {
  max-width: 1500px;
}

.img-uncover img {
  width: 100%;
  margin-bottom: 32px;
}

.base-title {
  line-height: 60px;
  color: #09192a
}
.base-sub {
  line-height: 32px;
  color: #82a6be;
}

.text-center {
  text-align: center;
  padding: 100px 30px 30px 30px;
  width: 100%;
  margin: 0 auto;

  .img-uncover {
    margin-top: 48px;
  }
}
.base-wrap.align-center {
  padding: 160px 30px 30px 30px;
  align-items: center;
}
.base-wrap {
  padding: 30px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .down {
    margin-top: 120px;
  }
  .item {
    flex: 1;
  }
  .left {
    margin-right: 32px;
  }
  .right {
    margin-left: 32px;
  }

  .base-info {
    line-height: 28px;
    color: #3c546e;
  }
}

.img-uncover {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;

  img {
    width: 100%;
    transform: scale(1.2);
    transition: transform 1.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  &.show:hover img {
    transition-delay: 0s;
    transform: scale(1.02);
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 110%;
    height: 110%;
    // background: #f1f1f1;
    transition: transform 1s cubic-bezier(.77,.15,0,.99);
    z-index: 4;
  }

  &.grey:after {
    background: #ededed;
  }

  &.show {
    &:after {
      transform: translateY(-100%);
    }
    img {
      //transition-delay: 0.4s;
      transform: scale(1);
    }
  }
}

.about1:after {
  background: rgb(215, 232, 249)
}
.about2:after {
  background: rgb(217, 234, 249)
}
.about3:after {
  background: rgb(238, 246, 252)
}
@media(max-width: 768px){
  .base-wrap{
    flex-direction: column;
    align-items: initial !important;
    .right{
      margin-left: 0;
      margin-top: 30px;
    }
    .left{
      margin-right: 0;
    }
  }
  .base-title{
    font-size: 20px;
    line-height: normal;
    padding: 17px 0;
  }
}
</style>
